import _defineProperty from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import classnames from 'classnames2';
import { kebabCase } from 'lodash';
import React from 'react';
import { Icon } from '../../Icon/Icon';
import styles from '../Select.Option/Select.Option.scss';
export var SelectChild = /*#__PURE__*/function (_React$Component) {
  _inherits(SelectChild, _React$Component);

  var _super = _createSuper(SelectChild);

  function SelectChild() {
    var _this;

    _classCallCheck(this, SelectChild);

    _this = _super.apply(this, arguments);
    _this.hoverTarget = null;

    _this.setHoverTarget = function (node) {
      _this.hoverTarget = node;
    };

    _this.handleHover = function (event) {
      if (!_this.props.disabled) {
        _this.props.onHover(_this.props.value, _this.hoverTarget);
      }
    };

    return _this;
  }

  _createClass(SelectChild, [{
    key: "render",
    value: function render() {
      var _classnames;

      var props = this.props;
      var optionClasses = classnames(styles.option, styles["indentation".concat(props.indentLevel)], (_classnames = {}, _defineProperty(_classnames, styles.optionSelected, props.selected), _defineProperty(_classnames, styles.optionDisabled, props.disabled), _classnames));
      return React.createElement("div", {
        className: classnames(styles.listItem, _defineProperty({}, styles.optionDisabled, props.disabled)),
        role: "listitem",
        onClick: props.disabled ? null : function () {
          return props.onClick(props.value);
        },
        onMouseOver: this.handleHover,
        "data-test": props.dataTest,
        ref: this.setHoverTarget
      }, React.createElement("div", {
        className: optionClasses,
        "data-test": "select-option-text-".concat(kebabCase(props.label))
      }, props.prefixIcon && React.createElement("div", {
        className: styles.iconWrapper
      }, props.prefixIcon), React.createElement("div", {
        className: classnames(styles.primary, styles.primaryChild),
        "data-test": "select-option-primary-text-".concat(kebabCase(props.label))
      }, props.label), React.createElement(Icon, {
        icon: "arrow-caret-down",
        className: styles.caret
      })));
    }
  }]);

  return SelectChild;
}(React.Component);
SelectChild.defaultProps = {
  indentLevel: 0
};
SelectChild.displayName = 'Select.Child';